/**
 * @file: 货架拖拽
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../../cubeTree/index';
import Utils from '../../../utils/util';
import DragSyStem from '../../../dragSyStem/index';
import ShelfDragRuner from './shelfDrag';

let dragRuner;

function init(): void {
    let shelfs: CubeId[] = CubeTree.findCubeByType('shelf');

    dragRuner = new ShelfDragRuner();
    shelfs.forEach((cubeId: CubeId): void => {
        add(cubeId);
    });
}

function add(cubeId: CubeId): void {
    let dragNode: DragCubeNode = DragSyStem.get(cubeId);

    if (dragNode.isInital) {
        return;
    }
    dragNode.isInital = true;
    dragNode.on('dragStart', (params: DragStartParams): void => {
        dragRuner.dragStart(params.transfer, cubeId);
    });

    dragNode.on('drag', Utils.throttle((params: DragParams): void => {
        dragRuner.drag(params);
    }, 100));

    dragNode.on('dragEnd', (params: DragEndParams): void => {
        dragRuner.dragEnd(params);
    });
}

export default {
    init,
    add
};
